import { useQuery } from "@tanstack/react-query"
import { useI18nState } from "@myvp/shared/src/i18n/i18n-state-provider"
import defaultDateFnsLocale from "date-fns/locale/en-US"

export const getDecimalSeparator = (locale: Intl.LocalesArgument) =>
  // oxlint-disable-next-line eslint-js/no-restricted-properties
  (1.1).toLocaleString(locale ?? "en-US").substring(1, 2)

export const getLocalizedDecimalString = (
  value: string | number,
  separator: string
) => String(value).replace(".", separator)

export const getDateFnsLanguageLocaleFile = async (
  locale: string
): Promise<import("date-fns").Locale | undefined> => {
  try {
    const result = await (
      await import(
        `@myvp/shared/src/i18n/datetime/date-fns-locales/locale-${locale}`
      )
    ).default
    return result
  } catch (error) {
    // oxlint-disable-next-line no-console
    console.error(error)
    // oxlint-disable-next-line no-console
    console.error("Could not import date-fns locale file for locale: ", locale)
    // NOTE: this needs to return `undefined` to catch missing entries when new language support is added
    return undefined
  }
}
export const useDateFnsLanguageLocale = (localeOverride?: string) => {
  const { locale: uiLocale } = useI18nState()

  const locale = localeOverride ?? uiLocale

  const { data } = useQuery({
    queryKey: ["useDateFnsLanguageLocale", locale],
    queryFn: async () => {
      return (
        (await getDateFnsLanguageLocaleFile(locale)) ?? defaultDateFnsLocale
      )
    },
    placeholderData: (data) => data,
  })
  return { locale: data }
}
